module.exports = __webpack_public_path__ + "static/media/FeedBack-red.d76c10bf.svg";